module.exports = __webpack_public_path__ + "img/48.1cfabce0.jpg";